import axios from "axios";

export const getLoggedIn = () => {
    return axios.get("/authentication/loggedIn");
};